import NavD from '@/pages/manageCatalogue/NavD';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, Divider, Stack, Form, Input, ButtonToolbar, Button, Panel, Message, toaster, InputGroup } from 'rsuite';
import MenuIcon from '@rsuite/icons/Menu';
import ugr from '@/UGRoute';
import globalIP from '@/GlobelIP';
import EyeCloseIcon from '@rsuite/icons/EyeClose';
import VisibleIcon from '@rsuite/icons/Visible';
// import { toaster, Message } from 'your-toaster-library';  // Make sure to import toaster

const ChangePassword = () => {
  const [openMenuBar, setOpenMenuBar] = useState(false);
  const [userData, setUserData] = useState(null);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const dataFromSession = localStorage.getItem('useid');
  const Name = JSON.parse(dataFromSession);
  console.log('Name', Name);
useEffect(() => {
  fetchUser()
}, [])

const fetchUser = async () => {
  // Get the 'useid' from localStorage and trim any quotes around it
  const useid = localStorage.getItem('useid').replace(/"/g, '');

  // Construct the URL using the cleaned 'useid'
  const response = await fetch(`${globalIP}/api/user-details?populate=*&pagination[page]=1&sort[0]=id:desc&filters[Username]=${useid}`);
  
  // Parse the response
  const json = await response.json();
  console.log('json ', json);
  setUserData(json.data[0]);
};

// const handleSavePassword = async () => {
//   // Trim any leading or trailing spaces from the password fields
//   const trimmedOldPassword = oldPassword.trim();
//   const trimmedNewPassword = newPassword.trim();
//   const trimmedConfirmPassword = confirmPassword.trim();

//   if (trimmedNewPassword !== trimmedConfirmPassword) {
//     setMessage('New password and confirmation password do not match!');
//     return;
//   }

//   if (trimmedOldPassword !== userData.attributes.Password) {
//     setMessage('Old password is incorrect!');
//     return;
//   }

//   // Check if any password fields are empty after trimming
//   if (!trimmedOldPassword || !trimmedNewPassword || !trimmedConfirmPassword) {
//     setMessage('Passwords cannot be empty or contain only spaces!');
//     return;
//   }

//   const payload = {
//     data: {
//       Password: trimmedNewPassword, // Update the password field
//     },
//   };

//   console.log('Sending payload:', payload);

//   try {
//     // Assuming the user data includes the user's ID, e.g., userData.id
//     console.log('userData.id1', userData);
//     console.log('userData.id2', userData.id);
    
//     const response = await fetch(`${globalIP}/api/user-details/${userData.id}`, {
//       method: 'PUT', // Update the password
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(payload),
//     });

//     if (!response.ok) {
//       const errorData = await response.json(); // Get JSON response if available
//       console.error('Error response:', errorData);
//       setMessage(`Error: ${errorData.message || 'Unable to update password.'}`);
//       return;
//     }

//     const result = await response.json();
//     console.log('Password updated successfully:', result);
    
//     // Show success message via toaster
//     toaster.push(
//       <Message showIcon type="success">
//         Password updated successfully!
//       </Message>,
//       { placement: 'topCenter' }
//     );

//     setOldPassword('');
//     setNewPassword('');
//     setConfirmPassword('');
//   } catch (error) {
//     console.error('Error during password update:', error);

//     // Show error message via toaster
//     toaster.push(
//       <Message showIcon type="error">
//         An error occurred while updating the password.
//       </Message>,
//       { placement: 'topCenter' }
//     );
//   }
// };

const handleSavePassword = async () => {
  // Trim any leading or trailing spaces from the password fields
  const trimmedOldPassword = oldPassword.trim();
  const trimmedNewPassword = newPassword.trim();
  const trimmedConfirmPassword = confirmPassword.trim();

  if (trimmedNewPassword !== trimmedConfirmPassword) {
    toaster.push(
      <Message showIcon type="error">
       New password and confirmation password do not match!
      </Message>,
      { placement: 'topCenter' }
    );
    // setMessage('New password and confirmation password do not match!');
    return;
  }

  if (trimmedOldPassword !== userData.attributes.Password) {
    // setMessage('Old password is incorrect!');
    toaster.push(
      <Message showIcon type="error">
        Old password is incorrect!
      </Message>,
      { placement: 'topCenter' }
    );
    return;
  }

  // Check if any password fields are empty after trimming
  if (!trimmedOldPassword || !trimmedNewPassword || !trimmedConfirmPassword) {
    toaster.push(
      <Message showIcon type="error">
        Passwords cannot be empty or contain only spaces!
      </Message>,
      { placement: 'topCenter' }
    );
    // setMessage('Passwords cannot be empty or contain only spaces!');
    return;
  }

  const payload = {
    data: {
      Password: trimmedNewPassword, // Update the password field
    },
  };

  console.log('Sending payload:', payload);

  try {
    // Assuming the user data includes the user's ID, e.g., userData.id
    console.log('userData.id1', userData);
    console.log('userData.id2', userData.id);

    const response = await fetch(`${globalIP}/api/user-details/${userData.id}`, {
      method: 'PUT', // Update the password
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json(); // Get JSON response if available
      console.error('Error response:', errorData);
      setMessage(`Error: ${errorData.message || 'Unable to update password.'}`);
      return;
    }

    const result = await response.json();
    console.log('Password updated successfully:', result);

    // Refresh user data by re-fetching it
    await fetchUser();

    // Show success message via toaster
    toaster.push(
      <Message showIcon type="success">
        Password updated successfully!
      </Message>,
      { placement: 'topCenter' }
    );

    // Clear the password fields
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
  } catch (error) {
    console.error('Error during password update:', error);

    // Show error message via toaster
    toaster.push(
      <Message showIcon type="error">
        An error occurred while updating the password.
      </Message>,
      { placement: 'topCenter' }
    );
  }
};

const [visible, setVisible] = React.useState(false);
const [visible2, setVisible2] = React.useState(false);
const [visible3, setVisible3] = React.useState(false);
const handleChange = () => {
  setVisible(!visible);
};
const handleChange2 = () => {
  setVisible2(!visible2);
};
const handleChange3 = () => {
  setVisible3(!visible3);
};

const styles = {
  width: 300
};
  return (
    <>
      <Stack
        className="table-toolbar product-head"
        justifyContent="space-between"
        style={{ marginTop: '15px' }}
      >
        <Stack direction="column" alignItems="flex-start">
          <Stack direction="column" alignItems="flex-start" className="product-det">
            <Stack direction="row" alignItems="flex-start" spacing={157}>
              {/* <NavD activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} /> */}
              <h3 className="title">Change Password</h3>
              <div onClick={() => setOpenMenuBar(!openMenuBar)}>
                <MenuIcon className="burgerMenu1" />
                {/* <CloseIcon className='burgerMenu1'/> */}
              </div>
            </Stack>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={`/${ugr}/dashboard`}>Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Product</Breadcrumb.Item>
            </Breadcrumb>
          </Stack>
        </Stack>
      </Stack>
      <Divider style={{ marginTop: '-10px' }} />

        <Panel
          shaded
           className="row row1"
          style={{ width: '700px',marginTop:'10px', backgroundColor: '#fff' }}
        >
          <Form layout="horizontal" style={{ marginTop: '30px' }}>
            <Form.Group controlId="name-6">
              <Form.ControlLabel>Username</Form.ControlLabel>
              <Form.Control
                name="username"
                placeholder={Name || 'Username'} 
                readOnly 
              />
            </Form.Group>
            <Form.Group controlId="password-6">
              <Form.ControlLabel>Old Password</Form.ControlLabel>
              <InputGroup inside style={styles}>
                <Input
                name="oldPassword"
                autoComplete="off"
                value={oldPassword}
                onChange={setOldPassword}
                type={visible ? 'text' : 'password'} />
                <InputGroup.Button onClick={handleChange}>
                  {visible ? <VisibleIcon /> : <EyeCloseIcon />}
                </InputGroup.Button>
              </InputGroup>
            </Form.Group>
            <Form.Group controlId="password-7">
              <Form.ControlLabel>New Password</Form.ControlLabel>
              <InputGroup inside style={styles}>
                <Input
               name="newPassword"
               autoComplete="off"
               value={newPassword}
               onChange={setNewPassword}
                type={visible2 ? 'text' : 'password'} />
                <InputGroup.Button onClick={handleChange2}>
                  {visible2 ? <VisibleIcon /> : <EyeCloseIcon />}
                </InputGroup.Button>
              </InputGroup>
            </Form.Group>
            <Form.Group controlId="password-8">
              <Form.ControlLabel>Confirm Password</Form.ControlLabel>
              <InputGroup inside style={styles}>
                <Input
                name="confirmPassword"
                autoComplete="off"
                value={confirmPassword}
                onChange={setConfirmPassword}
                type={visible3 ? 'text' : 'password'} />
                <InputGroup.Button onClick={handleChange3}>
                  {visible3 ? <VisibleIcon /> : <EyeCloseIcon />}
                </InputGroup.Button>
              </InputGroup>
            </Form.Group>
            {message && <p style={{ color: 'red', marginTop: '-10px' , marginBottom:'-5px'}}>{message}</p>}
          </Form>
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' , marginTop:"15px"}}>
          <Button color="cyan" appearance="primary"  onClick={handleSavePassword}>
            Save
          </Button>
        </div>
        </Panel>
      
    </>
  );
};

export default ChangePassword;
